<template>
<div class="content">
<container v-if="!loaded"><loading /></container>

<div class="md-layout" v-if="loaded">
    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom:15px">
        <h4 class="application-title" style="font-weight: bold;">{{application.service_name}}</h4>
    </div>
    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50" style="display: flex;">
        <container>
            <h4 class="application-title" style="font-weight: bold;">{{translate(locale.reviewing_comment)}}</h4>
            <div class="container">
                <div class="timeline">
                    <div class="timeline-container" v-for="(timeline, index) in timeline_list">
                        <div class="timeline-icon"></div>
                        <div class="timeline-body">
                            <h4 class="timeline-title">
                                <template v-if="timeline.status == 'REVIEWING'">
                                    <span class="badge"> {{timeline.user_name}} ({{timeline.unit_name}})</span>
                                </template>
                                <template v-else>
                                    <span class="badge">{{translate(config.getStatus(timeline.status))}}</span>
                                </template>

                                <template v-if="timeline.status == 'APPROVED' || timeline.status == 'STAMPED' || timeline.status == 'STAMPED' || timeline.status == 'COMPLETED' || timeline.status == 'RETURNED' ||  timeline.status == 'REJECTED'">
                                    <span class="badge"> {{translate(locale.by)}} {{timeline.user_name}} ({{timeline.unit_name}})</span>
                                </template>
                                
                                <span class="timeline-date">  •  {{translate(config.datelify(timeline.created_date))}}</span>
                            </h4>
                            <p class="timeline-comment" v-if="timeline.comment">{{timeline.comment}}</p>
                            <p class="timeline-comment" v-if="timeline.comment_to_user != ''">{{translate(locale.comment_to_applicant)}}: <br>{{timeline.comment_to_user}}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right">
                <md-button class="md-raised md-primary action-button" v-if="permission_list.includes('BACKWARD')" @click="openAction('BACKWARD')"><i class="material-icons button-icon">undo</i> {{translate(locale.backward)}}</md-button>
                <md-button class="md-raised md-primary action-button" v-if="permission_list.includes('FORWARD')" @click="openAction('FORWARD')"><i class="material-icons button-icon">send</i> {{translate(locale.forward)}}</md-button>
                <md-button class="md-raised md-primary action-button" v-if="permission_list.includes('RETURN')" @click="openAction('RETURN')"><i class="material-icons button-icon">assignment_return</i> {{translate(locale.return_back)}}</md-button>
                <md-button class="md-raised md-primary action-button" v-if="permission_list.includes('REJECT')" @click="openAction('REJECT')"><i class="material-icons button-icon">playlist_remove</i> {{translate(locale.reject)}}</md-button>
                <md-button class="md-raised md-primary action-button" v-if="permission_list.includes('APPROVE')" @click="openAction('APPROVE')"><i class="material-icons button-icon">check_circle</i> {{translate(locale.approve)}}</md-button>
                <md-button class="md-raised md-primary action-button" v-if="permission_list.includes('STAMP')" @click="openAction('STAMP')"><i class="material-icons button-icon">verified</i> {{translate(locale.stamp)}}</md-button>
                <md-button class="md-raised md-primary action-button" v-if="permission_list.includes('COMPLETE')" @click="openAction('COMPLETE')"><i class="material-icons button-icon">fact_check</i> {{translate(locale.complete)}}</md-button>
            </div>
        </container>
    </div>

    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-50" style="display: flex;">
        <container>
            <h4 class="application-title" style="font-weight: bold;">{{translate(locale.workspace)}}</h4>
            <div class="md-layout">
                <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                    <form-textarea v-model="workspace.comment_to_user" :label="locale.comment_to_applicant" type="text" :required="false" :height="100" />
                </div>
                <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
                    <form-textarea v-model="workspace.note" :label="locale.internal_note" type="text" :required="false" :height="100"/>
                </div>
                <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
                    <md-button class="md-raised md-primary" @click="save_workspace()"><i class="material-icons button-icon">save</i> {{translate(locale.save)}}</md-button>
                </div>
            </div>
           
            <h4 class="application-title" style="font-weight: bold;">{{translate(locale.hpc_resource)}}</h4>
            <div class="md-layout">
                <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
                    <md-button class="md-raised md-primary action-button" @click="openAction('ASSIGN-HPC')"><i class="material-icons button-icon">add</i> {{translate(locale.assign_hpc)}}</md-button>   
                </div>
            </div>
        </container>
    </div>
    
    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
        <container>
            <h4 class="text-primary text-center"><b>{{translate(locale.application_form)}}</b></h4>
            <HPC_FORM :data="application" v-if="service_form_hash == 'HPC_FORM'"/>
        </container>
    </div>
</div>
<transition name="fade" mode="out-in">
    <div class="md-overlay md-fixed md-dialog-overlay" v-show="action.show" @click="closeAction()"></div>
</transition>

<div class="md-dialog md-theme-default dialog-container"v-if="action.name == 'FORWARD'">
    <div class="md-layout" style="width: 100%;">
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
            <h4 class="text-primary"><b>{{translate(locale.forward)}}</b></h4>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-select v-model="action.unit_id" :label="locale.receive_unit" :list="forward_list" />
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-input v-model="action.comment" :label="locale.comment" type="text"/>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <md-button class="md-raised md-secondary" style="margin-right: 5px;" v-for="suggestion in suggestion_list" @click="comment(suggestion.text)"><b>{{suggestion.text}}</b></md-button>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
            <md-button class="md-raised md-danger action-button" @click="closeAction()"><i class="material-icons button-icon">cancel</i> {{translate(locale.cancel)}}</md-button>
            <md-button class="md-raised md-primary action-button" @click="forward()"><i class="material-icons button-icon">check_circle</i> {{translate(locale.confirm)}}</md-button>
        </div>
    </div>
</div>

<div class="md-dialog md-theme-default dialog-container" v-if="action.name == 'BACKWARD'">
    <div class="md-layout" style="width: 100%;">
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
            <h4 class="text-primary"><b>{{translate(locale.backward)}}</b></h4>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-select v-model="action.unit_id" :label="locale.receive_unit" :list="backward_list" />
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-input v-model="action.comment" :label="locale.comment" type="text"/>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <md-button class="md-raised md-secondary" style="margin-right: 5px;" v-for="suggestion in suggestion_list" @click="comment(suggestion.text)"><b>{{suggestion.text}}</b></md-button>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
            <md-button class="md-raised md-danger action-button" @click="closeAction()"><i class="material-icons button-icon">cancel</i> {{translate(locale.cancel)}}</md-button>
            <md-button class="md-raised md-primary action-button" @click="backward()"><i class="material-icons button-icon">check_circle</i> {{translate(locale.confirm)}}</md-button>
        </div>
    </div>
</div>

<div class="md-dialog md-theme-default dialog-container" v-if="action.name == 'APPROVE'">
    <div class="md-layout" style="width: 100%;">
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
            <h4 class="text-primary"><b>{{translate(locale.approve)}}</b></h4>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-select v-model="action.unit_id" :label="locale.receive_unit" :list="forward_list" />
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-input v-model="action.comment" :label="locale.comment" type="text"/>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <md-button class="md-raised md-secondary" style="margin-right: 5px;" v-for="suggestion in suggestion_list" @click="comment(suggestion.text)"><b>{{suggestion.text}}</b></md-button>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
            <md-button class="md-raised md-danger action-button" @click="closeAction()"><i class="material-icons button-icon">cancel</i> {{translate(locale.cancel)}}</md-button>
            <md-button class="md-raised md-primary action-button" @click="approve()"><i class="material-icons button-icon">check_circle</i> {{translate(locale.confirm)}}</md-button>
        </div>
    </div>
</div>

<div class="md-dialog md-theme-default dialog-container" v-if="action.name == 'RETURN'">
    <div class="md-layout" style="width: 100%;">
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
            <h4 class="text-primary"><b>{{translate(locale.return_back)}}</b></h4>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-textarea v-model="action.comment_to_user" :label="locale.comment_to_applicant" type="text" :height="100" />
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-input v-model="action.comment" :label="locale.internal_comment" type="text"/>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <md-button class="md-raised md-secondary" style="margin-right: 5px;" v-for="suggestion in suggestion_list" @click="comment(suggestion.text)"><b>{{suggestion.text}}</b></md-button>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
            <md-button class="md-raised md-danger action-button" @click="closeAction()"><i class="material-icons button-icon">cancel</i> {{translate(locale.cancel)}}</md-button>
            <md-button class="md-raised md-primary action-button" @click="return_back()"><i class="material-icons button-icon">check_circle</i> {{translate(locale.confirm)}}</md-button>
        </div>
    </div>
</div>

<div class="md-dialog md-theme-default dialog-container" v-if="action.name == 'REJECT'">
    <div class="md-layout" style="width: 100%;">
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
            <h4 class="text-primary"><b>{{translate(locale.reject)}}</b></h4>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-textarea v-model="action.comment_to_user" :label="locale.comment_to_applicant" type="text" :height="100" />
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <form-input v-model="action.comment" :label="locale.internal_comment" type="text"/>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
            <md-button class="md-raised md-secondary" style="margin-right: 5px;" v-for="suggestion in suggestion_list" @click="comment(suggestion.text)"><b>{{suggestion.text}}</b></md-button>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
            <md-button class="md-raised md-danger action-button" @click="closeAction()"><i class="material-icons button-icon">cancel</i> {{translate(locale.cancel)}}</md-button>
            <md-button class="md-raised md-primary action-button" @click="reject()"><i class="material-icons button-icon">check_circle</i> {{translate(locale.confirm)}}</md-button>
        </div>
    </div>
</div>

<div class="md-dialog md-theme-default dialog-container"v-if="action.name == 'COMPLETE'">
    <div class="md-layout" style="width: 100%;">
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100" style="margin-bottom: 15px;">
            <h4 class="text-primary"><b>{{translate(locale.complete)}}</b></h4>
        </div>
        <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
            <md-button class="md-raised md-danger action-button" @click="closeAction()"><i class="material-icons button-icon">cancel</i> {{translate(locale.cancel)}}</md-button>
            <md-button class="md-raised md-primary action-button" @click="complete()"><i class="material-icons button-icon">check_circle</i> {{translate(locale.confirm)}}</md-button>
        </div>
    </div>
</div>

</div>
</template>

<script>
    import HPC_FORM from "../../forms/HPC_FORM.vue";
    import Certificate from "../../components/Certificate.vue";
    import Preview from "../../components/Preview.vue";

    export default {
        components: { HPC_FORM },
        created() {
            this.getApplication();
        },
        data() {
            return {
                loaded: false,
                form_list: ["HPC_FORM"],
				service_form_hash: "",
                application: null,
                timeline_list: [],
                permission_list: [],
                forward_list: [],
                backward_list: [],
                suggestion_list: [],
                workspace: {
                    comment_to_user: "",
                    note: "",
                    certificate_data: []
                },
                action: {
                    show: false,
                    name: "",
                    comment_to_user: "",
                    comment: "",
                    reference: "",
                    reference_date: "",
                    unit_id: ""
                },

            }
        },
        methods: {
            getApplication() {
                this.loaded = false;
                this.$http.get(this.config.api + "/user/application/get_pending/" + this.$route.params.hash).then(data => {

                    if (data.body.status == 'success') {
						this.loaded = true;
						this.service_form_hash = data.body.data.application.service_form_hash;
                        this.application = data.body.data.application;
                        this.timeline_list = data.body.data.timeline_list;
                        this.forward_list = data.body.data.forward_list;
                        this.backward_list = data.body.data.backward_list;
                        
                        this.suggestion_list = data.body.data.suggestion_list;

                        for(let i = 0; i < data.body.data.permission_list.length; i++) {
                            this.permission_list.push(data.body.data.permission_list[i].code);
                        }

                        this.workspace.comment_to_user = data.body.data.application.comment_to_user;
                        this.workspace.note = data.body.data.application.note;

                    } else {
						this.$router.push("/pending_applications");
					}
                });
            },
            save_workspace() {
                this.$http.post(this.config.api + "/user/application/save", {
					hash: this.$route.params.hash,
                    workspace: this.workspace
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({message: "Success !||ជោគជ័យ។", icon: 'check_circle', type: 'success'});
					}
				})
            },
            forward() {
                if(String(this.action.unit_id).length < 1 || String(this.action.comment).length < 1) {
                    this.$notification.notify({message: "Please fill in information !||សូមបំពេញព័ត៌មាន។", icon: 'error', type: 'error'});
                    return false;
                }
                this.$store.state.pending.is = true;
                this.$http.post(this.config.api + "/user/application/forward", {
					hash: this.$route.params.hash,
                    action: this.action
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({message: "Success !||ជោគជ័យ។", icon: 'check_circle', type: 'success'});
                        this.$router.push("/pending_applications");  
					}
                    this.$store.state.pending.is = false;
				})
            },
            backward() {
                if(String(this.action.unit_id).length < 1 || String(this.action.comment).length < 1) {
                    this.$notification.notify({message: "Please fill in information !||សូមបំពេញព័ត៌មាន។", icon: 'error', type: 'error'});
                    return false;
                }
                this.$store.state.pending.is = true;
                this.$http.post(this.config.api + "/user/application/backward", {
					hash: this.$route.params.hash,
                    action: this.action
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({message: "Success !||ជោគជ័យ។", icon: 'check_circle', type: 'success'});
                        this.$router.push("/pending_applications");  
					}
                    this.$store.state.pending.is = false;
				})
            },
            return_back() {
                if(String(this.action.comment_to_user).length < 1 || String(this.action.comment).length < 1) {
                    this.$notification.notify({message: "Please fill in information !||សូមបំពេញព័ត៌មាន។", icon: 'error', type: 'error'});
                    return false;
                }
                this.$store.state.pending.is = true;
                this.$http.post(this.config.api + "/user/application/return_back", {
					hash: this.$route.params.hash,
                    action: this.action
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({message: "Success !||ជោគជ័យ។", icon: 'check_circle', type: 'success'});
                        this.$router.push("/pending_applications");  
					}
                    this.$store.state.pending.is = false;
				})
            },
            approve() {
                if(String(this.action.unit_id).length < 1 || String(this.action.comment).length < 1) {
                    this.$notification.notify({message: "Please fill in information !||សូមបំពេញព័ត៌មាន។", icon: 'error', type: 'error'});
                    return false;
                }
                this.$store.state.pending.is = true;
                this.$http.post(this.config.api + "/user/application/approve", {
					hash: this.$route.params.hash,
                    action: this.action
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({message: "Success !||ជោគជ័យ។", icon: 'check_circle', type: 'success'});
                        this.$router.push("/pending_applications");
					}
                    this.$store.state.pending.is = false;
				})
            },

            complete() {
                this.$store.state.pending.is = true;
                this.$http.post(this.config.api + "/user/application/complete", {
					hash: this.$route.params.hash,
                    action: this.action
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({message: "Success !||ជោគជ័យ។", icon: 'check_circle', type: 'success'});
                        this.$router.push("/pending_applications"); 
					}
                    this.$store.state.pending.is = false;
				})
            },
            reject() {
                if(String(this.action.comment_to_user).length < 1 || String(this.action.comment).length < 1) {
                    this.$notification.notify({message: "Please fill in information !||សូមបំពេញព័ត៌មាន។", icon: 'error', type: 'error'});
                    return false;
                }
                this.$store.state.pending.is = true;
                this.$http.post(this.config.api + "/user/application/reject", {
					hash: this.$route.params.hash,
                    action: this.action
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({message: "Success !||ជោគជ័យ។", icon: 'check_circle', type: 'success'});
                        this.$router.push("/pending_applications");
					}
                    this.$store.state.pending.is = false;
				})
            },
            openAction(name) {
                this.action.show = true;
                this.action.name = name;

                if((name == "APPROVE" || name == "STAMP" || name == "FORWARD") && this.forward_list.length == 1) {
                    this.action.unit_id = this.forward_list[0].id;
                }
                if(name == "BACKWARD" && this.backward_list.length == 1) {
                    this.action.unit_id = this.backward_list[0].id;
                }
                if(name == "RETURN" || name == "REJECT") {
                    this.action.comment_to_user = this.workspace.comment_to_user;
                }
                if(name == "ASSIGN-NUMBER") {
                    this.action.reference_date = (new Date).toISOString();
                }
            },
            closeAction() {
                this.action.show = false;
                this.action.name = "";
            },
            comment(text) {
                this.action.comment = text;
            }
        }
    }
</script>

<style scoped>
    .dialog-container {
        width: 90%; 
        max-width: 800px !important; 
        padding: 15px; 
        border-radius: 6px;
    }
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity .1s
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0
    }
    .action-button {
        margin-left: 8px !important;
    }
    .timeline {

        position: relative;
        padding-left: 3rem;
        margin: 0 0 0 10px;
        color: #353690;
    }
    .timeline .timeline-container {
        position: relative;
        margin-bottom: 20px;
    }
    .timeline .timeline-container .timeline-icon {
        position: absolute;
        left: -55px;
        top: 20px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #353690;
    }

    .timeline .timeline-container .timeline-body {
        background: #F7F7F7;
        border-radius: 6px;
        padding: 5px 15px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
    }

    .timeline-date {
        margin-bottom: 0;
        font-size: 13px;
    }
    .timeline .timeline-container .timeline-body:before {
        content: "";
        background: inherit;
        width: 20px;
        height: 20px;
        display: block;
        position: absolute;
        top:20px;
        left: -10px;
        transform: rotate(45deg);
        border-radius: 0 0 0 6px;
    }
    .timeline .timeline-container .timeline-body .timeline-title {
        margin-bottom: 8px;
        margin-top: 0px;
    }
    .timeline .timeline-container .timeline-body .timeline-title .badge {
        /* padding: 4px 8px; */
        border-radius: 3px;
        font-size: 15px;
        font-weight: bold;
    }
    .timeline-comment {
        white-space: pre-wrap;
    }
</style>


// WEBPACK FOOTER //
// src/pages/PendingApplications/Detail.vue